export type SearchItems = {
    mp_id?: number;
    maker_name: string;
    mp_product_name: string;
    mp_product_name_search: string;
    mp_model_number1: string;
    mp_model_number1_search: string;
};

export const SEARCH_ITEMS_INIT: SearchItems = {
    maker_name: '',
    mp_product_name: '',
    mp_product_name_search: '',
    mp_model_number1: '',
    mp_model_number1_search: '',
};

// /api/search/list response
export type SearchApiResponse = {
    items: Array<SearchItems>;
    count: number;
};

export const SEARCH_API_INIT: SearchApiResponse = {
    items: [],
    count: 0,
};

// /api/search request
export type SearchWordRequest = {
    query_string: string;
};

// API ERROR
export const SEARCH_API_ERRORS = {
    REQUEST_ERROR_3001: 'REQUEST_ERROR(3001)',
    REQUEST_ERROR_3001_STATUS_CODE: 'REQUEST_ERROR(3001)_%1',
    REQUEST_ERROR_3002: 'REQUEST_ERROR(3002)',
    REQUEST_ERROR_3002_STATUS_CODE: 'REQUEST_ERROR(3002)_%1',
};
